exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-block[data-v-1107611c]{display:flex;flex-direction:column;align-items:center}.paid-at[data-v-1107611c]{line-height:1.3}.paid-date[data-v-1107611c]{font-weight:600;font-size:12px}.paid-time[data-v-1107611c]{font-size:11px;color:#666}.paid-label[data-v-1107611c]{font-size:10px;font-weight:500}", ""]);

// exports
